import { mlsGetStates } from '@/utils/helpers';

const mlsSetStatesList = (): Array<string> => {
    const statesMap: Record<string, string> = mlsGetStates();
    const statesList: Array<string> = [];
    for ( const state in statesMap ) {
        statesList.push( state.toLowerCase() );
        statesList.push( statesMap[ state ].toLowerCase() );
    }
    return statesList;
}
export default mlsSetStatesList;